'use strict';

import { view } from '@/functions';

const prefix = '/accounts';
const info_scopes = { title: 'Accounts', scopes: ['read_accounts', 'write_accounts'] };

const info_legacy_component = () => view('accounts/info');

const info_v2_component = () => view('accounts/infov2');

const info_tabs = [
    { path: '', name: 'accounts-info', tab: 'details' },
    { path: '/overview', name: 'accounts-info-overview', tab: 'overview' },
    { path: '/companies', name: 'accounts-info-companies', tab: 'companies' },
    { path: '/verifications', name: 'accounts-info-verifications', tab: 'verifications' },
    { path: '/compliance', name: 'accounts-info-compliance', tab: 'compliance' },
    { path: '/transactions', name: 'accounts-info-transactions', tab: 'transactions' },
    { path: '/activity', name: 'accounts-info-activity', tab: 'activity' },
    { path: '/gateways', name: 'accounts-info-gateways', tab: 'gateways' },
    { path: '/pricings', name: 'accounts-info-pricings', tab: 'pricings' },
    { path: '/partner-rates', name: 'accounts-info-partner-rates', tab: 'partner-rates' },
    { path: '/billing', name: 'accounts-info-billing', tab: 'billing' },
    { path: '/configuration', name: 'accounts-info-configuration', tab: 'configuration' },
    { path: '/ai-conversations', name: 'accounts-info-ai-conversations', tab: 'ai-conversations' },
    { path: '/support-scopes', name: 'accounts-info-support-scopes', tab: 'support-scopes' },
];

const info_v2_tabs = [
    { path: '', name: 'accounts-info-v2', tab: 'details' },
    { path: '/overview', name: 'accounts-info-v2-overview', tab: 'overview' },
    { path: '/companies', name: 'accounts-info-v2-companies', tab: 'companies' },
    { path: '/verifications', name: 'accounts-info-v2-verifications', tab: 'verifications' },
    { path: '/compliance', name: 'accounts-info-v2-compliance', tab: 'compliance' },
    { path: '/transactions', name: 'accounts-info-v2-transactions', tab: 'transactions' },
    { path: '/activity', name: 'accounts-info-v2-activity', tab: 'activity' },
    { path: '/gateways', name: 'accounts-info-v2-gateways', tab: 'gateways' },
    { path: '/pricings', name: 'accounts-info-v2-pricings', tab: 'pricings' },
    { path: '/partner-rates', name: 'accounts-info-v2-partner-rates', tab: 'partner-rates' },
    { path: '/billing', name: 'accounts-info-v2-billing', tab: 'billing' },
    { path: '/configuration', name: 'accounts-info-v2-configuration', tab: 'configuration' },
    { path: '/ai-conversations', name: 'accounts-info-v2-ai-conversations', tab: 'ai-conversations' },
    { path: '/support-scopes', name: 'accounts-info-v2-support-scopes', tab: 'support-scopes' },
];

export default [
    {
        path: prefix,
        name: 'accounts',
        meta: { ...info_scopes }, 
        component: () => view('accounts/index'),
    },
    ...info_tabs.map(t => ({
        path: `${prefix}/info${t.path}`,
        name: t.name,
        meta: { ...info_scopes, tab: t.tab, isAccountInfoV2: true },
        component: info_v2_component,
    })),
    ...info_v2_tabs.map(t => ({
        path: `${prefix}/v2${t.path}`,
        name: t.name,
        meta: { ...info_scopes, tab: t.tab },
        component: info_legacy_component,
    })),
    {
        path: `${prefix}/legacy-mode`,
        name: 'accounts-legacy-mode',
        meta: { ...info_scopes, title: 'Accounts (legacy)' },
        redirect: () => ({ name: 'accounts', query: { view: 'legacy' } }),
    },
];
